import Vue from 'vue'
import { format } from 'date-fns'

/**
 * @desc  Normalizes product names (removing free sample) with trademark.
 * @param object $product - Product object
 * @param string $stringCase - Handle letter case
 */
Vue.filter('withSuffix', function (product, stringCase) {
  if (typeof product !== 'object') {
    throw new TypeError('[filters] no product object provided')
  }

  function splice(str, index, count, add) {
    return str.slice(0, index) + add + str.slice(index + count)
  }

  if (!['original', 'variant', 'sample'].includes(product.type)) {
    return product.name
  }

  const productId = product.ogId || product.id
  const uppercaseName =
    productId !== 18 ? product.name.toUpperCase() : 'BEAUTY zzZz'
  const productName = stringCase === 'uppercase' ? uppercaseName : product.name

  const suffix = [1, 2, 3, 5, 7, 9, 14, 19].includes(productId)
    ? '\u00AE'
    : '\u2122'

  if (!product.isSample) {
    return productName + suffix
  } else {
    const position = product.name.indexOf(' Free Sample')

    return splice(productName, position, 1, suffix + ' ')
  }
})

Vue.filter('withoutSample', product => {
  if (typeof product !== 'object') {
    throw new TypeError('[filters] no product object provided')
  }

  if (!product.isSample) {
    throw new Error('[filters] product is not sample')
  }

  const productName =
    product.ogId !== 48
      ? product.name.replace(' Free Sample', '')
      : 'Skin Heroes Pre+Probiotic'
  const suffix = [1, 2, 3, 5, 7, 9, 14, 19].includes(product.ogId)
    ? '\u00AE'
    : '\u2122'

  return productName + suffix
})

Vue.filter('currency', function (value, decimal = 0) {
  return '$' + Number(value).toFixed(decimal)
})

Vue.filter('format', function (value, dateFormat = 'MMM Do YYYY') {
  const date = value instanceof Date ? value : new Date(value)

  // TODO: add type check
  return format(date, dateFormat)
})

Vue.filter('titleCase', function (value) {
  return value
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.substring(1))
    .join(' ')
})

Vue.filter('plural', function (word, count) {
  return Number(count) == 1 ? word : word + 's'
})

Vue.filter('truncate', function (value, limit) {
  return value.length > limit ? `${value.substr(0, limit - 1)}...` : value
})

Vue.filter('capitalize', function (key) {
  if (typeof key !== 'string') {
    throw new TypeError(`${key} is not a string`)
  }
  return key.charAt(0).toUpperCase() + key.slice(1)
})
